import { createRouter, createWebHistory } from 'vue-router'
import NotFound from "@/components/Shared/NotFound.vue"

const routes = [
  {

    path: '/',
    component: () => import("@/views/Auth/Login.vue")
  },
  {
    path: '/login',
    component: () => import("@/views/Auth/Login.vue")
  },
  {
    path: '/dashboard',
    component: () => import("@/views/Dashboard.vue")
  },
  {
    path: '/customers',
    component: () => import("@/views/Customers/Customers.vue")
  },
  {
    path: '/products',
    component: () => import("@/views/Products/Products.vue")
  },
  {
    path: '/loan-applications',
    component: () => import("@/views/Loans/LoanApplications.vue")
  },
  {
    path: '/loan-contracts',
    component: () => import("@/views/Loans/LoanContracts.vue")
  },
  {
    path: '/roles',
    component: () => import("@/views/IAM/Roles.vue")
  },
  {
    path: '/users',
    component: () => import("@/views/IAM/Users.vue")
  },
  {
    path: '/b2c-transactions',
    component: () => import("@/views/Payments/B2CTransactions.vue")
  },
  {
    path: '/c2b-transactions',
    component: () => import("@/views/Payments/C2BTransactions.vue")
  },
  {
    path: '/accounts',
    component: () => import("@/views/Payments/Accounts.vue")
  }, 
  {
    path: '/repayment-reminder',
    component: () => import("@/views/Settings/RepaymentReminder.vue")
  },

  {
    path: '/reports/customer-list',
    component: () => import("@/views/Reports/CustomerListReport.vue")
  },
  {
    path: '/reports/loans-register',
    component: () => import("@/views/Reports/LoansRegisterReport.vue")
  },
  {
    path: '/reports/disbursement',
    component: () => import("@/views/Reports/DisbursementReport.vue")
  },
  {
    path: '/reports/collection',
    component: () => import("@/views/Reports/CollectionReport.vue")
  },
  {
    path: '/reports/qualified-topup',
    component: () => import("@/views/Reports/QualifiedTopUpReport.vue")
  }  ,
  {
    path: '/leads',
    component: () => import("@/views/Customers/Leads.vue")
  },

  {
    path: '/clients',
    component: () => import("@/views/Settings/Clients.vue")
  },
  {
    path: '/maker-checker-configuration',
    component: () => import("@/views/Approvals/MakerChecker.vue")
  },
  {
    path: '/maker-checker-requests',
    component: () => import("@/views/Approvals/MakerCheckerRequests.vue")
  },
  {
    path: '/app-version-policy',
    component: () => import("@/views/Settings/AppVersionPolicy.vue")
  },
  {
    path: '/security-questions',
    component: () => import("@/views/IAM/SecurityQuestion.vue")
  },
  {
    path: '/devices',
    component: () => import("@/views/IAM/Devices.vue")
  },
  {
    path: '/onboarding-log',
    component: () => import("@/views/Customers/Onboarding.vue")
  },
  {
    path: '/unauthorized',
    component: () => import("@/components/Shared/InvalidPermissions.vue")
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
